import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { Box, FormHelperText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ICustomDatePickerProps {
  date: string;
  handleOneTimeChange: (_field: string, _value: string) => void;
  minDate?: string | null;
  maxDate?: string | null;
  label?: string;
  required?: boolean;
  error?: string;
}
function CustomDatePicker({
  date,
  handleOneTimeChange,
  minDate,
  maxDate,
  label,
  required,
  error,
}: ICustomDatePickerProps) {
  const { t } = useTranslation();
  return (
    <Box display="flex" flexDirection="column" justifyContent="center">
      <Typography variant="meta" color="primary" mb={0.5}>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          format="DD / MM / YYYY"
          value={date === '' ? null : dayjs(date)}
          onChange={(newValue: Dayjs | null) => {
            const formattedDate = newValue ? dayjs(newValue).format('YYYY-MM-DD') : '';
            handleOneTimeChange('dob', formattedDate);
          }}
          minDate={minDate ? dayjs(minDate) : undefined}
          maxDate={maxDate ? dayjs(maxDate) : undefined}
          slotProps={{
            textField: {
              variant: 'outlined',
              fullWidth: true,
              sx: {
                '& .MuiOutlinedInput-root': {
                  height: '48px',
                  borderRadius: '10px',
                  '& fieldset': {
                    padding: '12px',
                    color: 'primary.main',
                    border: error
                      ? '1px solid var(--Alert-Sunset-Orange, #FF9A9A)'
                      : '1px solid var(--Accent-Moonstone-Blue, #7CAEBE)',
                  },
                  '&:hover fieldset': {
                    border: error
                      ? '1px solid var(--Alert-Sunset-Orange, #FF9A9A)'
                      : '1px solid var(--Accent-Moonstone-Blue, #7CAEBE)',
                  },
                  '&.Mui-focused fieldset': {
                    border: error
                      ? '1px solid var(--Alert-Sunset-Orange, #FF9A9A)'
                      : '1px solid var(--Accent-Moonstone-Blue, #7CAEBE)',
                  },
                },
              },
            },
          }}
        />
      </LocalizationProvider>
      {error && (
        <FormHelperText sx={{ color: 'red', marginTop: '-2px' }}>{t(error)}</FormHelperText>
      )}
    </Box>
  );
}

CustomDatePicker.defaultProps = {
  minDate: dayjs(),
  maxDate: null,
};

export default CustomDatePicker;
